import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface TourCloseConfirmationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const TourCloseConfirmationModal = ({ onConfirm, onCancel }: TourCloseConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <div className="tour-confirmation-modal">
      <Dialog open={true} onOpenChange={onCancel}>
        <DialogContent className="sm:max-w-[425px] z-[10001]">
          <DialogHeader>
            <div className="flex items-center gap-3 mb-2">
              <div className="h-10 w-10 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
                <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-500" />
              </div>
              <DialogTitle className="text-lg">
                {t('tour.closeConfirmation.title')}
              </DialogTitle>
            </div>
            <DialogDescription className="text-base">
              {t('tour.closeConfirmation.message')}
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="gap-2 sm:gap-0">
            <Button variant="outline" onClick={onCancel}>
              {t('tour.closeConfirmation.cancel')}
            </Button>
            <Button variant="destructive" onClick={onConfirm}>
              {t('tour.closeConfirmation.confirm')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
